var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconServerConfiguration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.957,
    height: 41.957,
    viewBox: "0 0 41.957 41.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_33561",
    "data-name": "Group 33561",
    transform: "translate(-1577 -98)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13737",
    "data-name": "Rectangle 13737",
    width: 41.957,
    height: 41.957,
    rx: 8,
    transform: "translate(1577 98)",
    fill: "#eff4ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_66724",
    "data-name": "Group 66724",
    transform: "translate(1529 109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93664",
    "data-name": "Path 93664",
    d: "M75.611,4.165,71.832.59A2.147,2.147,0,0,0,70.35,0H63.156A2.158,2.158,0,0,0,61,2.156V17.911a2.158,2.158,0,0,0,2.156,2.156H74.13a2.158,2.158,0,0,0,2.156-2.156V5.731a2.164,2.164,0,0,0-.674-1.566ZM74.469,4.7H71.543a.2.2,0,0,1-.2-.2V1.749ZM74.13,18.891H63.156a.981.981,0,0,1-.98-.98V2.156a.981.981,0,0,1,.98-.98h7.015V4.507a1.373,1.373,0,0,0,1.372,1.372h3.567V17.911A.981.981,0,0,1,74.13,18.891Z",
    transform: "translate(0 0)",
    fill: "#1162fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93665",
    "data-name": "Path 93665",
    d: "M137.21,200h-8.622a.588.588,0,0,0,0,1.176h8.622a.588.588,0,0,0,0-1.176Z",
    transform: "translate(-64.374 -192.161)",
    fill: "#1162fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93666",
    "data-name": "Path 93666",
    d: "M137.21,280h-8.622a.588.588,0,0,0,0,1.176h8.622a.588.588,0,0,0,0-1.176Z",
    transform: "translate(-64.374 -269.026)",
    fill: "#1162fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93667",
    "data-name": "Path 93667",
    d: "M131.438,360h-2.85a.588.588,0,0,0,0,1.176h2.85a.588.588,0,0,0,0-1.176Z",
    transform: "translate(-64.374 -345.891)",
    fill: "#1162fb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServerConfiguration);
export default __webpack_public_path__ + "static/media/IconServerConfiguration.50002611dbdfcc73ce004a7d8beb4184.svg";
export { ForwardRef as ReactComponent };